<template>
  <div>
  	<div class="" :style="(isMobile()) ? '' : 'display: flex; justify-content: space-between;' ">
      <div>
  	    <button v-if="!quoteGenerated" :style="(isMobile()) ? 'text-align: center; margin-right:75px; margin-left:75px; margin-bottom: 10px;' : '' " @click="$router.push('dashboard')" tabindex="-1" substrate="button" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
  	      <span style="padding-right: 4px;">←</span> Back to Dashboard
  	    </button>
      </div>
      <hr v-if="isMobile() && !quoteGenerated && printName && !confirmQuote">
      <div v-if="!confirmQuote" :style="(isMobile()) ? 'margin-right:47px; margin-left:47px; margin-top: 15px;' : '' ">
        <span v-if="!quoteGenerated && printName">
          <span  class="left:0px;"><span style="color: black; font-weight: bold; font-size: 18px; padding-right: 10px;">Print Name:</span> <span style="font-size: 15px;">{{ printName }}</span></span>
          <button v-if="!quoteGenerated" :style="(isMobile()) ? 'text-align: center; align-items: center; margin-left: 95px; margin-right: 95px;' : '' " @click="showPrintModal = true" tabindex="-1" substrate="button" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white; margin-left: 30px;">
            <span style="padding-right: 4px;"></span> Edit
          </button>
        </span>
      </div>
      <div style="padding-left: 200px;">
        
      </div>
      <!--
      <div  style="margin-top: 20px;">
  	    <span  class="left:0px;" style="padding-right: 25px;"><span style="color: black; font-weight: bold; font-size: 18px;">Print Name:</span> <span style="font-size: 15px;">{{ printName }}</span></span>
        <span @click="showPrintModal = true" style="background-color: black; color: white; border-radius: 5px; padding-right: 15px; padding-left: 15px; padding-top: 5px; padding-bottom: 5px; ">Edit</span>
      </div>
      -->
	</div>
    <ModalIdle v-if="isIdle" />

    <printQuote 
      v-if="quoteGenerated"
      :displayItems="displayItems"
      :selectedSize="selectedSize"
      :selectedSubstrate="selectedSubstrate"
      :selectedGsm="selectedGsm"
      :selectedHandle="selectedHandle"
      :selectedHandleColor="selectedHandleColor"
      :selectedFinish="selectedFinish"
      :selectedCardboard="selectedCardboard"
      :selectedJslit="selectedJslit"
      :selectedColorCount="selectedColorCount"
      :selectedPrint="selectedPrint"
      :selectedIp="selectedIp"
      :selectedQuantity="selectedQuantity"
      :otherEffects="otherEffects"
      :quote="quote"
      :quoteId="quoteId"
      :casePackAmount="casePackAmount"
      :otherFees="otherFees"
      :selectedSide="selectedSide"
      :selectedWeight="selectedWeight"
      :customSize="customSize"
      :userData="userData"
      :printName="printName"
      :customQuote="customQuote"
    />
    
    <div style="display: flex; justify-content: space-between;">
      <div style=""></div>
      <div v-if="showPrintModal" class="overlay">
        <div :style="(isMobile()) ? 'width: 350px;' : 'width: 600px;'" style="background: white; box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12); border-radius: 4px; height: 250px;">
          <div style="color: #38404f;display: flex; align-items: center; justify-content: center; padding-top: 25px; padding-bottom: 10px; font-weight: bold;">
            Enter the Print Name
          </div>
          <hr>
          <div style="text-align: center; padding-top: 20px;">
            <b-form-input
              id="print_name"
              v-model="printNameTemp"
              label="text"
              placeholder="Enter Print Name"
              @keyup.enter="closePrintModal"
              style="width: 50%; display: inline-block; padding-left: 10px;"
            ></b-form-input>
            <br>
            <small class="text-danger" style="width: 50%; margin-left: 50% margin-bottom:30px;">{{ printNameError }}</small>
            
  	      <div style="padding:10px;"></div>
            <button @click="closePrintModal" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
                 Save
              </button>
          </div>
        </div>
      </div>
      <div style=""></div>
    </div>

    <div style="display: flex; justify-content: space-between;">
      <div style=""></div>
      <div v-if="confirmQuote" class="overlay">
        <div :style="(isMobile()) ? 'width: 350px;' : 'width: 600px;'" style="background: white; box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12); border-radius: 4px; height: 250px;">
          <div style="color: #38404f;display: flex; align-items: center; justify-content: center; padding-top: 25px; padding-bottom: 10px; font-weight: bold;">
            Add Another Item?
          </div>
          <hr>
          <div style="text-align: center; padding-top: 20px;">
            <div style="padding:10px;"></div>
            <button @click="addItem" tabindex="-1" substrate="button" class="wizard-btn mr-2" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
                 Add Item
            </button>
            <button @click="quoteConfirmed" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
               Next
            </button>
          </div>
        </div>
      </div>
      <div style=""></div>
    </div>

    <div v-if="isMobile() && !quoteGenerated && !showPrintModal && !confirmQuote" style="align-content: center; align-items: center; text-align: center; justify-content: center; vertical-align: middle !important;">
      <validation-observer
        style="text-align: center;"
        ref="sizeRules"
        tag="form"
      >
        <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class=""
          >
            <h5 class="mb-0" style="background-color: black; margin-right: 150px; margin-left: 150px; padding-top: 10px; padding-bottom: 10px; font-weight: bold; font-size: 25px; color: white;">
              1
            </h5>
          </b-col>
        </b-row>

        <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class=""
          >
            <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
              Size
            </h5>
            <small class="text-muted" style="font-size: 15px;">
              What size would you like?
            </small>
          </b-col>

          <b-col cols="1" class="mb-2"></b-col>

        </b-row>

        <b-row style="">
          <b-col md="12">
            <b-form-group
              label=""
              label-for="size"
            >
              <validation-provider
                #default="{ errors }"
                name="size"
                rules="required"
              >

                <v-select
                  id="size"
                  v-model="selectedSize"
                  :options="sizeOptions"
                  :selectable="option => option.value != 'select_value'"
                  label="text"
                  placeholder="Select a Size"
                  :style="sizeWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                />
                <small class="text-danger">{{ sizeError }}</small>
              </validation-provider>

              <validation-provider
                v-if="sizeWidth"
                #default="{ errors }"
                name="size_custom"
                rules="required"
              >
                <b-form-input
                  v-if="sizeWidth"
                  id="size_custom"
                  v-model="customSize"
                  label="text"
                  placeholder="Enter Size"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customSizeError }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
              Quantity
            </h5>
            <small class="text-muted" style="font-size: 15px;">
              Select a quantity
            </small>
          </b-col>
        </b-row>

        <b-row style="">
          <b-col md="12">
            <b-form-group
              label=""
              label-for="quanitity"
            >
              <validation-provider
                #default="{ errors }"
                name="quanitity"
                rules="required"
              >

                <v-select
                  id="quanitity"
                  v-model="selectedQuantity"
                  :options="quantityOptions"
                  :selectable="option => option.value != 'select_value'"
                  label="text"
                  placeholder="Select a Quanitity"
                  :style="quantityWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                />
                <small class="text-danger">{{ quantityError }}</small>
              </validation-provider>

              <validation-provider
                v-if="quantityWidth"
                #default="{ errors }"
                name="quantity_custom"
                rules="required"
              >
                <b-form-input
                  v-if="quantityWidth"
                  id="quantity_custom"
                  v-model="customQuantity"
                  label="text"
                  type="number"
                  placeholder="Enter Quantity"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customQuantityError }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
         
        <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
              Finish
            </h5>
            <small class="text-muted" style="font-size: 15px;">
              Choose the Finish
            </small>
          </b-col>
        </b-row>

        <b-row style="">
          <b-col md="12">
            <b-form-group
              label=""
              label-for="finish"
            >
              <validation-provider
                #default="{ errors }"
                name="finish"
                rules="required"
              >

                <v-select
                  id="finish"
                  v-model="selectedFinish"
                  :options="finishOptions"
                  :selectable="option => option.value != 'select_value'"
                  label="text"
                  placeholder="Select a Finish"
                  :style="finishWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                />
                <small class="text-danger">{{ finishError }}</small>
              </validation-provider>

              <validation-provider
                v-if="finishWidth"
                #default="{ errors }"
                name="finish_custom"
                rules="required"
              >
                <b-form-input
                  v-if="finishWidth"
                  id="finish_custom"
                  v-model="customFinish"
                  label="text"
                  placeholder="Enter Finish"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customFinishError }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
              Color Count
            </h5>
            <small class="text-muted" style="font-size: 15px;">
              Select a Color Count
            </small>
          </b-col>
        </b-row>

        <b-row style="margin-bottom: 100px;">

          <b-col md="5">
            <b-form-group
              label=""
              label-for="color_count"
            >
              <validation-provider
                #default="{ errors }"
                name="color_count"
                rules="required"
              >

                <v-select
                  id="finish"
                  v-model="selectedColorCount"
                  :options="colorCountOptions"
                  :selectable="option => option.value != 'select_value'"
                  label="text"
                  placeholder="Select a Color Count"
                  :style="colorCountWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                />
                <small class="text-danger">{{ colorError }}</small>
              </validation-provider>

              <validation-provider
                v-if="colorCountWidth"
                #default="{ errors }"
                name="color_count_custom"
                rules="required"
              >
                <b-form-input
                  v-if="colorCountWidth"
                  id="finish_custom"
                  v-model="customColorCount"
                  label="text"
                  placeholder="Enter Color Count"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customColorCountError }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>
      </validation-observer>

      <validation-observer
          ref="substrateRules"
          tag="form"
        >
          <b-row style="margin-top: 50px;">
            <b-col
              cols="12"
              class=""
            >
              <h5 class="mb-0" style="background-color: black; margin-right: 150px; margin-left: 150px; padding-top: 10px; padding-bottom: 10px; font-weight: bold; font-size: 25px; color: white;">
                2
              </h5>
            </b-col>
          </b-row>

          <b-row style="margin-top: 50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Substrate
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the substrate
              </small>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="substrate"
              >
                <validation-provider
                  #default="{ errors }"
                  name="substrate"
                  rules="required"
                >
                  
                  <v-select
                    id="substrate"
                    placeholder="Select a Substrate"
                    v-model="selectedSubstrate"
                    :options="substrateOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="substrateWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ substrateError }}</small>
                </validation-provider>

                <validation-provider
                v-if="substrateWidth"
                #default="{ errors }"
                name="substrate_custom"
                rules="required"
              >
                <b-form-input
                  v-if="substrateWidth"
                  id="substrate_custom"
                  v-model="customSubstrate"
                  label="text"
                  placeholder="Enter Substrate"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customSubstrateError }}</small>
              </validation-provider>

              </b-form-group>
            </b-col>
          </b-row>

          <b-row style="margin-top: 50px; margin-bottom:50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                GSM
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the GSM
              </small>
            </b-col>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="gsm"
              >
                <validation-provider
                  #default="{ errors }"
                  name="gsm"
                  rules="required"
                >
                  
                  <v-select
                    id="gsm"
                    placeholder="Select a GSM"
                    v-model="selectedGsm"
                    :options="gsmOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="gsmWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ gsmError }}</small>
                </validation-provider>

                <validation-provider
                v-if="gsmWidth"
                #default="{ errors }"
                name="gsm_custom"
                rules="required"
              >
                <b-form-input
                  v-if="gsmWidth"
                  id="gsm_custom"
                  v-model="customGsm"
                  label="text"
                  placeholder="Enter GSM"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customGsmError }}</small>
              </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>

        <validation-observer
          ref="handleRules"
          tag="form"
        >
          <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class=""
          >
            <h5 class="mb-0" style="background-color: black; margin-right: 150px; margin-left: 150px; padding-top: 10px; padding-bottom: 10px; font-weight: bold; font-size: 25px; color: white;">
              1
            </h5>
          </b-col>
        </b-row>
        <!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! -->
        <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class=""
          >
            <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
              Handle Type
            </h5>
            <small class="text-muted" style="font-size: 15px;">
              Choose the Handle Type
            </small>
          </b-col>

          <b-col cols="1" class="mb-2"></b-col>

        </b-row>

        <b-row style="">
          <b-col md="12">
            <b-form-group
              label=""
              label-for="handle"
            >
              <validation-provider
                #default="{ errors }"
                name="handle"
                rules="required"
              >
                
                <v-select
                  id="handle"
                  placeholder="Select a Handle Type"
                  v-model="selectedHandle"
                  :options="handleOptions"
                  :selectable="option => option.value != 'select_value'"
                  label="text"
                  :style="handleWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                />
                <small class="text-danger">{{ handleError }}</small>
              </validation-provider>

              <validation-provider
                v-if="handleWidth"
                #default="{ errors }"
                name="handle_custom"
                rules="required"
              >
                <b-form-input
                  v-if="handleWidth"
                  id="handle_custom"
                  v-model="customHandle"
                  label="text"
                  placeholder="Enter Handle"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customHandleError }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
              Colored Handle?
            </h5>
            <small class="text-muted" style="font-size: 15px;">
              Select an Option
            </small>
          </b-col>
        </b-row>

        <b-row style="">
          <b-col md="12">
            <b-form-group
                label=""
                label-for="handle_color"
              >
                <validation-provider
                  #default="{ errors }"
                  name="handle"
                  rules="required"
                >
                  
                  <v-select
                    id="handle"
                    placeholder="Select an Option"
                    v-model="selectedHandleColor"
                    :options="handleColorOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="colorHandleWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ handleColorError }}</small>
                </validation-provider>

                <validation-provider
                v-if="colorHandleWidth"
                #default="{ errors }"
                name="color_handle_custom"
                rules="required"
              >
                <b-form-input
                  v-if="colorHandleWidth"
                  id="color_handle_custom"
                  v-model="customHandleColor"
                  label="text"
                  placeholder="Enter Handle Color"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customHandleColorError }}</small>
              </validation-provider>
              </b-form-group>
          </b-col>
        </b-row>

          <b-row style="margin-top: 50px;">
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
              J Slit
            </h5>
            <small class="text-muted" style="font-size: 15px;">
              Select an Option
            </small>
          </b-col>
        </b-row>

        <b-row style="">
          <b-col md="12">
            <b-form-group
                label=""
                label-for="jslit"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jslit"
                  rules="required"
                >
                  
                  <v-select
                    id="jslit"
                    placeholder="Select an Option"
                    v-model="selectedJslit"
                    :options="jslitOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="jslitWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ jslitError }}</small>
                </validation-provider>

                <validation-provider
                  v-if="jslitWidth"
                  #default="{ errors }"
                  name="jslit_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="jslitWidth"
                    id="jslit_custom"
                    v-model="customJslit"
                    label="text"
                    placeholder="Enter Jslit"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customJslitError }}</small>
                </validation-provider>
              </b-form-group>
          </b-col>
        </b-row>

          <b-row style="margin-top: 50px; margin-bottom:50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Cardboard Placement
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the Cardboard Placement
              </small>
            </b-col>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="cardboard"
              >
                <validation-provider
                  #default="{ errors }"
                  name="cardboard"
                  rules="required"
                >
                  
                  <v-select
                    id="cardboard"
                    placeholder="Select the Cardboard Position"
                    v-model="selectedCardboard"
                    :options="cardboardOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="cardboardWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ cardboardError }}</small>
                </validation-provider>

                <validation-provider
                v-if="cardboardWidth"
                #default="{ errors }"
                name="cardboard_custom"
                rules="required"
              >
                <b-form-input
                  v-if="cardboardWidth"
                  id="cardboard_custom"
                  v-model="customCardboard"
                  label="text"
                  placeholder="Enter Cardboard"
                  style="width: 50%; display: inline-block; padding-left: 10px;"
                ></b-form-input>
                <br>
                <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customCardboardError }}</small>
              </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>

        <validation-observer
          ref="PrintRules"
          tag="form"
        >
          <b-row style="margin-top: 50px;">
            <b-col
              cols="12"
              class=""
            >
              <h5 class="mb-0" style="background-color: black; margin-right: 150px; margin-left: 150px; padding-top: 10px; padding-bottom: 10px; font-weight: bold; font-size: 25px; color: white;">
                4
              </h5>
            </b-col>
          </b-row>
          <b-row style="margin-top: 50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Print Percentage
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the Print Percentage
              </small>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="print_percentage"
              >
                <validation-provider
                  #default="{ errors }"
                  name="print_percentage"
                  rules="required"
                >
                  
                  <v-select
                    id="print_percentage"
                    placeholder="Select the Print Percentage"
                    v-model="selectedPrint"
                    :options="PrintOptions"
                    :selectable="option => ! option.value.includes('select_value')"
                    label="text"
                    :style="printWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ printError }}</small>
                </validation-provider>

                <validation-provider
                  v-if="printWidth"
                  #default="{ errors }"
                  name="print_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="printWidth"
                    id="print_custom"
                    v-model="customPrint"
                    label="text"
                    placeholder="Enter Print"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customPrintError }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row style="margin-top: 50px; margin-bottom: 50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Inside Printing
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Do you want inside printing?
              </small>
            </b-col>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="inside_printing"
              >
                <validation-provider
                  #default="{ errors }"
                  name="inside_printing"
                  rules="required"
                >
                  
                  <v-select
                    id="inside_printing"
                    placeholder="Select an Option"
                    v-model="selectedIp"
                    :options="ipOptions"
                    :selectable="option => ! option.value.includes('select_value')"
                    label="text"
                    :style="ipWidth ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ insidePrintError }}</small>
                </validation-provider>

                <validation-provider
                  v-if="ipWidth"
                  #default="{ errors }"
                  name="ip_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="ipWidth"
                    id="ip_custom"
                    v-model="customIp"
                    label="text"
                    placeholder="Enter Inside Print"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ customIpError }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>

        <validation-observer
          ref="effectsRules"
          tag="form"
        >
          <b-row style="margin-top: 50px; margin-bottom: 50px;">
            <b-col
              cols="12"
              class=""
            >
              <h5 class="mb-0" style="background-color: black; margin-right: 150px; margin-left: 150px; padding-top: 10px; padding-bottom: 10px; font-weight: bold; font-size: 25px; color: white;">
                5
              </h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Other Effects
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Any other effects you would like to specify?
              </small>
            </b-col>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="effect"
              >
                <validation-provider
                  #default="{ errors }"
                  name="effect"
                  rules=""
                >
                  
                  <textarea
                    id="effect"
                    v-model="otherEffects"
                    style="width:350px; height:100px; border: 1px solid #d8d6de;; border-radius: 0.357rem; padding: 10px;"
                    placeholder="Type additional effects"
                  ></textarea>
                  <br>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>

        <button @click="formSubmitted" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white; margin-top: 25px;">
          <span style=""></span> Submit
        </button>
    </div>

    <form-wizard
      v-if="!quoteGenerated && !isMobile() && !showPrintModal && !confirmQuote"
      color="#000000"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Next"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- general details tab -->
      <tab-content
        title="General Details"
        :before-change="validationFormGeneral"
        style="text-align: center;"
      >
        <validation-observer
          ref="sizeRules"
          tag="form"
        >
          <b-row style="margin-top: 50px; margin-left: 100px;">
            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Size
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                What size would you like?
              </small>
            </b-col>

            <b-col cols="1" class="mb-2"></b-col>

            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Quantity
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Select a quantity
              </small>
            </b-col>
          </b-row>

          <b-row style="margin-left: 100px;">
            <b-col md="5">
              <b-form-group
                label=""
                label-for="size"
              >
                <validation-provider
                  #default="{ errors }"
                  name="size"
                  rules="required"
                >

                  <v-select
                    id="size"
                    v-model="selectedSize"
                    :options="sizeOptions"
                    :selectable="option => option.value != 'select_value'"
                  
                    label="text"
                    placeholder="Select a Size"
                    :style="selectedSize.value==1 ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedSize.value == '1'"
                  #default="{ errors }"
                  name="size_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedSize.value == '1'"
                    id="size_custom"
                    v-model="customSize"
                    label="text"
                    placeholder="Enter Size"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="1"></b-col>

            <b-col md="5">
              <b-form-group
                label=""
                label-for="quantity"
              >
                <validation-provider
                  #default="{ errors }"
                  name="quantity"
                  rules="required"
                >

                  <v-select
                    id="quantity"
                    v-model="selectedQuantity"
                    :options="quantityOptions"
                    :selectable="option => option.value != 'select_value'"
                  
                    label="text"
                    placeholder="Select a Quantity"
                    :style="selectedQuantity.value==1 ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedQuantity.value == '1'"
                  #default="{ errors }"
                  name="quantity_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedQuantity.value == '1'"
                    id="quantity_custom"
                    v-model="customQuantity"
                    label="text"
                    placeholder="Enter Quantity"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
           
          <b-row style="margin-top: 50px; margin-left: 100px;">
            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Finish
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the Finish
              </small>
            </b-col>

            <b-col cols="1" class="mb-2"></b-col>

            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Color Count
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Select a Color Count
              </small>
            </b-col>
          </b-row>
          <b-row style="margin-left: 100px; margin-bottom: 100px;">
            <b-col md="5">
              <b-form-group
                label=""
                label-for="finish"
              >
                <validation-provider
                  #default="{ errors }"
                  name="finish"
                  rules="required"
                >

                  <v-select
                    id="finish"
                    v-model="selectedFinish"
                    :options="finishOptions"
                    :selectable="option => option.value != 'select_value'"
                  
                    label="text"
                    placeholder="Select a Finish"
                    :style="selectedFinish.value==1 ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedFinish.value == '1'"
                  #default="{ errors }"
                  name="finish_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedFinish.value == '1'"
                    id="quantity_custom"
                    v-model="customFinish"
                    label="text"
                    placeholder="Enter Finish"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="1" class="mb-2"></b-col>

            <b-col md="5">
              <b-form-group
                label=""
                label-for="color_count"
              >
                <validation-provider
                  #default="{ errors }"
                  name="color_count"
                  rules="required"
                >

                  <v-select
                    id="color_count"
                    v-model="selectedColorCount"
                    :options="colorCountOptions"
                    :selectable="option => option.value != 'select_value'"
                  
                    label="text"
                    placeholder="Select a Color Count"
                    :style="selectedColorCount.value==1 ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedColorCount.value == '1'"
                  #default="{ errors }"
                  name="color_count_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedColorCount.value == '1'"
                    id="quantity_custom"
                    v-model="customColorCount"
                    label="text"
                    placeholder="Enter Color Count"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
                </b-form-group>
            </b-col>

          </b-row>
        </validation-observer>
      </tab-content>

      <!-- substrate / gsm tab -->
      <tab-content
        title="Substrate / GSM"
        :before-change="validationFormSubstrate"
        style="text-align: center;"
      >
        <validation-observer
          ref="substrateRules"
          tag="form"
        >
          <b-row style="margin-top: 50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Substrate
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the substrate
              </small>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="substrate"
              >
                <validation-provider
                  #default="{ errors }"
                  name="substrate"
                  rules="required"
                >
                  
                  <v-select
                    id="substrate"
                    placeholder="Select a Substrate"
                    v-model="selectedSubstrate"
                    :options="substrateOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="selectedSubstrate.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <validation-provider
                  v-if="selectedSubstrate.value == 'custom'"
                  #default="{ errors }"
                  name="substrate_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedSubstrate.value == 'custom'"
                    id="substrate_custom"
                    v-model="customSubstrate"
                    label="text"
                    placeholder="Enter Substrate"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row style="margin-top: 50px; margin-bottom:50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                GSM
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the GSM
              </small>
            </b-col>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="gsm"
              >
                <validation-provider
                  #default="{ errors }"
                  name="gsm"
                  rules="required"
                >
                  
                  <v-select
                    id="gsm"
                    placeholder="Select a GSM"
                    v-model="selectedGsm"
                    :options="gsmOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="selectedGsm.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedGsm.value == 'custom'"
                  #default="{ errors }"
                  name="gsm_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedGsm.value == 'custom'"
                    id="gsm_custom"
                    v-model="customGsm"
                    label="text"
                    placeholder="Enter GSM"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- additional details tab -->
      <tab-content
        title="Additional Details"
        :before-change="validationFormHandle"
        style="text-align: center;"
      >
        <validation-observer
          ref="handleRules"
          tag="form"
        >
        <!--!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!-->
          <b-row style="margin-top: 50px; margin-left: 100px;">
            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Handle Type
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the Handle Type
              </small>
            </b-col>

            <b-col cols="1" class="mb-2"></b-col>

            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Colored Handle?
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Select an Option
              </small>
            </b-col>
          </b-row>

          <b-row style="margin-left: 100px;">
            <b-col md="5">
              <b-form-group
                label=""
                label-for="handle"
              >
                <validation-provider
                  #default="{ errors }"
                  name="handle"
                  rules="required"
                >
                  
                  <v-select
                    id="handle"
                    placeholder="Select a Handle Type"
                    v-model="selectedHandle"
                    :options="handleOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="selectedHandle.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedHandle.value == 'custom'"
                  #default="{ errors }"
                  name="handle"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedHandle.value == 'custom'"
                    id="handle_custom"
                    v-model="customHandle"
                    label="text"
                    placeholder="Enter Handle"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="1"></b-col>

            <b-col md="5">
              <b-form-group
                label=""
                label-for="handle_color"
              >
                <validation-provider
                  #default="{ errors }"
                  name="handle_color"
                  rules="required"
                >
                  
                  <v-select
                    id="handle"
                    placeholder="Select an Option"
                    v-model="selectedHandleColor"
                    :options="handleColorOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="selectedHandleColor.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedHandleColor.value == 'custom'"
                  #default="{ errors }"
                  name="handle color"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedHandleColor.value == 'custom'"
                    id="handle_color_custom"
                    v-model="customHandleColor"
                    label="text"
                    placeholder="Enter Handle Color"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------------------------------------------------------->

          <b-row style="margin-top: 50px; margin-left: 100px;">
            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Cardboard Placement
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the Cardboard Placement
              </small>
            </b-col>

            <b-col cols="1" class="mb-2"></b-col>

            <b-col
              cols="5"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                J Slit
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Select an Option
              </small>
            </b-col>
          </b-row>

          <b-row style="margin-left: 100px; margin-bottom: 100px;">
            <b-col md="5">
              <b-form-group
                label=""
                label-for="cardboard"
              >
                <validation-provider
                  #default="{ errors }"
                  name="cardboard"
                  rules="required"
                >
                  
                  <v-select
                    id="cardboard"
                    placeholder="Select the Cardboard Position"
                    v-model="selectedCardboard"
                    :options="cardboardOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="selectedCardboard.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedCardboard.value == 'custom'"
                  #default="{ errors }"
                  name="cardboard"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedCardboard.value == 'custom'"
                    id="cardboard_custom"
                    v-model="customCardboard"
                    label="text"
                    placeholder="Enter Cardboard"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="1"></b-col>

            <b-col md="5">
              <b-form-group
                label=""
                label-for="jslit"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jslit"
                  rules="required"
                >
                  
                  <v-select
                    id="jslit"
                    placeholder="Select an Option"
                    v-model="selectedJslit"
                    :options="jslitOptions"
                    :selectable="option => option.value != 'select_value'"
                    label="text"
                    :style="selectedJslit.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedJslit.value == 'custom'"
                  #default="{ errors }"
                  name="color_count_custom"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedJslit.value == 'custom'"
                    id="jslit"
                    v-model="customJslit"
                    label="text"
                    placeholder="Enter Jslit"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          

          
        </validation-observer>
      </tab-content>

      
      <!-- printing tab  -->
      <tab-content
        title="Printing"
        :before-change="validationFormPrint"
        style="text-align: center;"
      >
        <validation-observer
          ref="PrintRules"
          tag="form"
        >
          <b-row style="margin-top: 50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Print Percentage
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Choose the Print Percentage
              </small>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="print_percentage"
              >
                <validation-provider
                  #default="{ errors }"
                  name="print_percentage"
                  rules="required"
                >
                  
                  <v-select
                    id="print_percentage"
                    placeholder="Select the Print Percentage"
                    v-model="selectedPrint"
                    :options="PrintOptions"
                    :selectable="option => ! option.value.includes('select_value')"
                    label="text"
                    :style="selectedPrint.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedPrint.value == 'custom'"
                  #default="{ errors }"
                  name="print"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedPrint.value == 'custom'"
                    id="print_custom"
                    v-model="customPrint"
                    label="text"
                    placeholder="Enter Print"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row style="margin-top: 50px; margin-bottom: 50px;">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Inside Printing
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Do you want inside printing?
              </small>
            </b-col>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="inside_printing"
              >
                <validation-provider
                  #default="{ errors }"
                  name="inside_printing"
                  rules="required"
                >
                  
                  <v-select
                    id="inside_printing"
                    placeholder="Select an Option"
                    v-model="selectedIp"
                    :options="ipOptions"
                    :selectable="option => ! option.value.includes('select_value')"
                    label="text"
                    :style="selectedPrint.value=='custom' ? 'width: 50%; display: inline-block; padding-right: 10px;' : ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                  v-if="selectedIp.value == 'custom'"
                  #default="{ errors }"
                  name="inside print"
                  rules="required"
                >
                  <b-form-input
                    v-if="selectedIp.value == 'custom'"
                    id="ip_custom"
                    v-model="customIp"
                    label="text"
                    placeholder="Enter Inside Print"
                    style="width: 50%; display: inline-block; padding-left: 10px;"
                  ></b-form-input>
                  <br>
                  <small class="text-danger" style="width: 50%; margin-left: 50%">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      
      <!-- other effects tab -->
      <tab-content
        title="Other Effects"
        :before-change="validationFormEffects"
        style="text-align: center;"
      >

      <validation-observer
          ref="effectsRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0" style="font-weight: bold; font-size: 30px; color: black;">
                Other Effects
              </h5>
              <small class="text-muted" style="font-size: 15px;">
                Any other effects you would like to specify?
              </small>
            </b-col>
            <b-col md="3">
            </b-col>
            <b-col md="6">
              <b-form-group
                label=""
                label-for="effect"
              >
                <validation-provider
                  #default="{ errors }"
                  name="effect"
                  rules=""
                >
                  
                  <textarea
                    id="effect"
                    v-model="otherEffects"
                    style="width:500px; height:100px; border: 1px solid #d8d6de;; border-radius: 0.357rem; padding: 10px;"
                    placeholder="Type additional effects"
                  ></textarea>
                  <br>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
        
      </tab-content>

    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from 'axios';
import html2pdf from "html2pdf.js";
import PrintQuote from './PrintQuote.vue'
import ModalIdle from "@/views/components/ModalIdle.vue"
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    PrintQuote,
    ModalIdle,
  },
  data() {
    return {
      sizeId: 2,
      gsmId: 9,
      printPercentage: 75,
      colorCount: 1,
      substrateId: 1,
      handleTypeId: 1,
      finishId: 1,
      cardboard: 'TOP',
      insidePrinting: 0,
      apiInfo: null,
      quote: 0,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      logo: require('@/assets/images/logo/favicon.png'),
      required,
      email,
      selectedSize: '',
      selectedSubstrate: '',
      selectedGsm: '',
      selectedHandle: '',
      selectedHandleColor: '',
      selectedFinish: '',
      customFinish: '',
      selectedCardboard: '',
      selectedJslit: '',
      selectedColorCount: '',
      selectedPrint: '',
      selectedIp: '',
      selectedQuantity: '',
      selectedSide: '',
      selectedWeight: '',
      otherEffects: '',
      sizeOptions: [{ value: 'select_value',  text: 'Select Value' }],
      substrateOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
      ],
      gsmOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
      ],
      handleOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
      ],
      finishOptions: [{ value: 'select_value',  text: 'Select Value' }],
      cardboardOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
        { value: 'NONE', text: 'None' },
        { value: 'TOP', text: 'Top' },
        { value: 'BOTTOM', text: 'Bottom' },
        { value: 'BOTH', text: 'Both' }
      ],
      jslitOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
        { value: '0', text: 'No' },
        { value: '1', text: 'Yes' },
      ],
      handleColorOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
        { value: '0', text: 'No' },
        { value: '1', text: 'Yes' },
      ],
      colorCountOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: '1', text: 'CUSTOM' },
        { value: '2', text: '1' },
        { value: '3', text: '2' },
        { value: '4', text: '3' },
        { value: '5', text: '4+' },
      ],
      PrintOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
        { value: '25',  text: '25%' },
        { value: '50',  text: '50%' },
        { value: '75',  text: '75%' },
        { value: '100', text: '100%' },
      ],
      ipOptions: [
        { value: 'select_value',  text: 'Select Value' },
        { value: 'custom', text: 'CUSTOM' },
        { value: '1',  text: 'Yes' },
        { value: '0',  text: 'No' },
      ],
      quantityOptions: [{ value: 'select_value',  text: 'Select Value' }],
      quoteGenerated: false,
      prices: {},
      customSize: '',
      customQuantity: '',
      customColorCount: '',
      customSubstrate: '',
      customGsm: '',
      customHandle: '',
      customHandleColor: '',
      customCardboard: '',
      customJslit: '',
      customPrint: '',
      customIp: '',
      insertStatus: '',
      quote_data: [],
      quoteId: 'JP042722564',
      casePackAmount: 0,
      userData: null,
      otherFees: [],
      cardboardAddOn: 0,
      finishAddOn: 0,
      sizeError: '',
      customSizeError: '',
      quantityError: '',
      customQuantityError: '',
      customColorCountError: '',
      customSubstrateError: '',
      customFinishError: '',
      customGsmError: '',
      customHandleError: '',
      customHandleColorError: '',
      customCardboardError: '',
      customJslitError: '',
      customPrintError: '',
      customIpError: '',
      finishError: '',
      colorError: '',
      substrateError: '',
      gsmError: '',
      handleError: '',
      handleColorError: '',
      cardboardError: '',
      jslitError: '',
      printError: '',
      insidePrintError: '',
      printName: '',
      printNameTemp: '',
      printNameError: '',
      sizeWidth: false,
      quantityWidth: false,
      showPrintModal: true,
      finishWidth: false,
      confirmQuote: false,
      quoteItems: [],
      requestQuantity: '',
      displayItems: {},
      quoteIteration: null,
      quoteResponse: [],
      pushedAmount: 0,
      customQuote: false,
      colorCountWidth: false,
      gsmWidth: false,
      handleWidth: false,
      colorHandleWidth: false,
      jslitWidth: false,
      cardboardWidth: false,
      printWidth: false,
      ipWidth: false,
      substrateWidth: false,
      userType: 'REG',
    }
  },
  watch: {
    printNameTemp() {
      if (this.printNameTemp) {
        this.printNameError = ''
      }
      else {
        this.printNameError = 'Print name is required'
      }
    },
    selectedSize() {
      if (this.isMobile()) {
        this.validateAll('size')
      }
    },
    customSize() {
      if (this.isMobile()) {
        this.validateAll('customSize')
      }
    },
    selectedQuantity() {
      if (this.isMobile()) {
        this.validateAll('quantity')
      }
    },
    customQuantity() {
      if (this.isMobile()) {
        this.validateAll('customQuantity')
      }
    },
    customColorCount() {
      if (this.isMobile()) {
        this.validateAll('customColorCount')
      }
    },
    customGsm() {
      if (this.isMobile()) {
        this.validateAll('customGsm')
      }
    },
    customHandle() {
      if (this.isMobile()) {
        this.validateAll('customHandle')
      }
    },
    customHandleColor() {
      if (this.isMobile()) {
        this.validateAll('customHandleColor')
      }
    },
    customCardboard() {
      if (this.isMobile()) {
        this.validateAll('customCardboard')
      }
    },
    customJslit() {
      if (this.isMobile()) {
        this.validateAll('customJslit')
      }
    },
    customPrint() {
      if (this.isMobile()) {
        this.validateAll('customPrint')
      }
    },
    customIp() {
      if (this.isMobile()) {
        this.validateAll('customIp')
      }
    },
    customSubstrate() {
      if (this.isMobile()) {
        this.validateAll('customSubstrate')
      }
    },
    customFinish() {
      if (this.isMobile()) {
        this.validateAll('customFinish')
      }
    },
    selectedFinish() {
      if (this.isMobile()) {
        this.validateAll('finish')
      }
    },
    selectedColorCount() {
      if (this.isMobile()) {
        this.validateAll('color')
      }
    },
    selectedSubstrate() {
      if (this.isMobile()) {
        this.validateAll('substrate')
      }
    },
    selectedGsm() {
      if (this.isMobile()) {
        this.validateAll('gsm')
      }
    },
    selectedHandle() {
      if (this.isMobile()) {
        this.validateAll('handle')
      }
    },
    selectedHandleColor() {
      if (this.isMobile()) {
        this.validateAll('handle_color')
      }
    },
    selectedCardboard() {
      if (this.isMobile()) {
        this.validateAll('cardboard')
      }
    },
    selectedJslit() {
      if (this.isMobile()) {
        this.validateAll('jslit')
      }
    },
    selectedPrint() {
      if (this.isMobile()) {
        this.validateAll('print')
      }
    },
    selectedIp() {
      if (this.isMobile()) {
        this.validateAll('insidePrint')
      }
    },
  },
  methods: {
    addItem() {
      this.selectedColorCount = ''
      this.customColorCount = ''
      this.customGsm = ''
      this.customHandle = ''
      this.customHandleColor = ''
      this.customCardboard = ''
      this.customJslit = ''
      this.customPrint = ''
      this.customIp = ''
      this.customSunstrate= ''
      this.selectedFinish = ''
      this.customFinish = ''
      this.selectedGsm = ''
      this.selectedHandle = ''
      this.selectedHandleColor = ''
      this.selectedSize = ''
      this.customSize = ''
      this.selectedSubstrate = ''
      this.selectedCardboard = ''
      this.selectedJslit = ''
      this.selectedPrint = ''
      this.selectedIp = ''
      this.selectedQuantity = ''
      this.customQuantity = ''
      this.requestQuantity = ''
      this.otherEffects = ''
      this.quote = ''

      this.confirmQuote = false
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    validateAll(val) {
      switch(val) {
        case 'size':
          if (!this.selectedSize) {
            this.sizeWidth = false
            this.sizeError = 'Size is required'
          }
          else {
            if (this.selectedSize.value == 1) {
              this.sizeWidth = true
            }
            else {
              this.sizeWidth = false
            }
            this.sizeError = ''
          }
          break;

        case 'customSize':
          if (!this.customSize) {
            this.customSizeError = 'Size is required'
          }
          else {
            this.customSizeError = ''
          }
          break;

        case 'quantity':
          if (!this.selectedQuantity) {
              this.quantityWidth = false
              this.quantityError = 'Quantity is required'
            }
            else {
              if (this.selectedQuantity.value == 1) {
                this.quantityWidth = true
              }
              else {
                this.quantityWidth = false
              }
              this.quantityError = ''
            }
          break;

        case 'finish':
          if (!this.selectedFinish) {
            this.finishWidth = false
            this.finishError = 'Finish is required'
          }
          else {
            if (this.selectedFinish.value == '1') {
              this.finishWidth = true
            }
            else {
              this.finishWidth = false
            }
            this.finishError = ''
          }
          break;

        case 'color':
          if (!this.selectedColorCount) {
            this.colorCountWidth = false
            this.colorError = 'Color Count is required'
          }
          else {
            if (this.selectedColorCount.value == 1) {
              this.colorCountWidth = true
            }
            else {
              this.colorCountWidth = false
            }
            if (this.customColorCount) {
              this.customColorCountError = ''
            }
            this.colorError = ''
          }
          break;

        case 'gsm':
          if (!this.selectedGsm) {
            this.gsmWidth = false
            this.gsmError = 'GSM is required'
          }
          else {
            if (this.selectedGsm.value == 'custom') {
              this.gsmWidth = true
            }
            else {
              this.gsmWidth = false
            }
            this.gsmError = ''
          }
          break;

        case 'handle':
          if (!this.selectedHandle) {
            this.handleWidth = false
            this.handleError = 'Handle Type is required'
          }
          else {
            if (this.selectedHandle.value == 'custom') {
              this.handleWidth = true
            }
            else {
              this.handleWidth = false
            }
            this.handleError = ''
          }
          break;

        case 'handle_color':
          if (!this.selectedHandleColor) {
            this.colorHandleWidth = false
            this.handleColorError = 'Handle Color is required'
          }
          else {
            if (this.selectedHandleColor.value == 'custom') {
              this.colorHandleWidth = true
            }
            else {
              this.colorHandleWidth = false
            }
            this.handleColorError = ''
          }
          break;

        case 'jslit':
          if (!this.selectedJslit) {
            this.jslitWidth = false
            this.jslitError = 'Jslit is required'
          }
          else {
            if (this.selectedJslit.value == 'custom') {
              this.jslitWidth = true
            }
            else {
              this.jslitCountWidth = false
            }
            this.jslitError = ''
          }
          break;

        case 'cardboard':
          if (!this.selectedCardboard) {
            this.cardboardWidth = false
            this.cardboardError = 'Cardboard is required'
          }
          else {
            if (this.selectedCardboard.value == 'custom') {
              this.cardboardWidth = true
            }
            else {
              this.cardboardWidth = false
            }
            this.cardboardError = ''
          }
          break;

        case 'print':
          if (!this.selectedPrint) {
            this.printWidth = false
            this.printError = 'Print Percentage is required'
          }
          else {
            if (this.selectedPrint.value == 'custom') {
              this.printWidth = true
            }
            else {
              this.printWidth = false
            }
            this.printError = ''
          }
          break;

        case 'insidePrint':
          if (!this.selectedIp) {
            this.ipWidth = false
            this.ipError = 'Inside Print is required'
          }
          else {
            if (this.selectedIp.value == 'custom') {
              this.ipWidth = true
            }
            else {
              this.ipWidth = false
            }
            this.ipError = ''
          }
          break;

        case 'substrate':
          if (!this.selectedSubstrate) {
            this.substrateWidth = false
            this.substrateError = 'Substrate is required'
          }
          else {
            if (this.selectedSubstrate.value == 'custom') {
              this.substrateWidth = true
            }
            else {
              this.substrateWidth = false
            }
            this.substrateError = ''
          }
          break;

        default:
          if (!this.selectedSize) {
            this.sizeWidth = false
            this.sizeError = 'Size is required'
          }
          else {
            if (this.selectedSize.value == 1) {
              this.sizeWidth = true
            }
            else {
              this.sizeWidth = false
            }
            this.sizeError = ''
          }

          if (!this.customSize) {
            this.customSizeError = 'Size is required'
          }
          else {
            this.customSizeError = ''
          }

          if (!this.selectedQuantity) {
            this.quantityWidth = false
            this.quantityError = 'Quantity is required'
          }
          else {
            if (this.selectedQuantity.value == 1) {
              this.quantityWidth = true
            }
            this.quantityError = ''
          }

          if (!this.customQuantity) {
            this.customQuantityError = 'Quantity is required'
          }
          else {
            this.customQuantityError = ''
          }

          if (!this.customFinish) {
            this.customFinishError = 'Finish is required'
          }
          else {
            this.customFinishError = ''
          }

          if (!this.customColorCount) {
            this.customColorCountError = 'Color Count is required'
          }
          else {
            this.customColorCountError = ''
          }

          if (!this.customGsm) {
            this.customGsmError = 'GSM is required'
          }
          else {
            this.customGsmError = ''
          }

          if (!this.customHandle) {
            this.customHandleError = 'Handle Type is required'
          }
          else {
            this.customHandleError = ''
          }

          if (!this.customHandleColor) {
            this.customHandleColorError = 'Handle Color is required'
          }
          else {
            this.customHandleColorError = ''
          }

          if (!this.customCardboard) {
            this.customCardboardError = 'Cardboard is required'
          }
          else {
            this.customCardboardError = ''
          }

          if (!this.customJslit) {
            this.customJslitError = 'Jslit is required'
          }
          else {
            this.customJslitError = ''
          }

          if (!this.customPrint) {
            this.customPrintError = 'Print is required'
          }
          else {
            this.customPrintError = ''
          }

          if (!this.customIp) {
            this.customIpError = 'Inside Print is required'
          }
          else {
            this.customIpError = ''
          }

          if (!this.customSubstrate) {
            this.customSubstrateError = 'Substrate is required'
          }
          else {
            this.customSubstrateError = ''
          }

          if (!this.selectedFinish) {
            this.finishWidth = false
            this.customFinishError = 'Quantity is required'
          }
          else {
            if (this.selectedFinish.value == 1) {
              this.finishWidth = true
            }
            this.customFinishError = ''
          }

          if (!this.selectedFinish) {
            this.quantityFinish = false
            this.finishError = 'Finish is required'
          }
          else {
            this.finishError = ''
          }

          if (!this.selectedColorCount) {
            this.colorError = 'Color Count is required'
          }
          else {
            this.colorError = ''
          }

          if (!this.selectedSubstrate) {
            this.substrateError = 'Substrate is required'
          }
          else {
            this.substrateError = ''
          }

          if (!this.selectedGsm) {
            this.gsmError = 'GSM is required'
          }
          else {
            this.gsmError = ''
          }

          if (!this.selectedHandle) {
            this.handleError = 'Handle Type is required'
          }
          else {
            this.handleError = ''
          }

          if (!this.selectedHandleColor) {
            this.handleColorError = 'Colored Handle is required'
          }
          else {
            this.handleColorError = ''
          }

          if (!this.selectedCardboard) {
            this.cardboardError = 'Cardboard Placement is required'
          }
          else {
            this.cardboardError = ''
          }

          if (!this.selectedJslit) {
            this.jslitError = 'J Slit Placement is required'
          }
          else {
            this.jslitError = ''
          }

          if (!this.selectedPrint) {
            this.printError = 'Print Percentage is required'
          }
          else {
            this.printError = ''
          }

          if (!this.selectedIp) {
            this.insidePrintError = 'Inside Printing is required'
          }
          else {
            this.insidePrintError = ''
          }

          if (!this.printModal) {
            this.printModalError = 'Print Percent is required'
          }
          else {
            this.printModalError = ''
          }
          break;
      }
    },
    closePrintModal(){
      if(this.printNameTemp){
        this.printName = this.printNameTemp
        this.showPrintModal = false
      }
      else {
        this.printNameError = 'Print name is required'
      }
    },
    formSubmitted() {
      if (this.isMobile()) {

        if (this.sizeError == '' && this.quantityError == '' && this.finishError == '' && this.colorError == '' && this.substrateError == '' && this.gsmError == '' && this.handleError == '' && this.jslitError == '' && this.handleColorError == '' && this.cardboardError == '' && this.printError == '' && this.insidePrintError == '') {
          if ((!this.selectedSize.value != '1' || (this.selectedSize.value == '1' && this.customSizeError == '')) && (!this.selectedQuantity.value != '1' || (this.selectedQuantity.value == '1' && this.customQuantityError == '')) && (!this.selectedFinish.value != '1' || (this.selectedFinish.value == '1' && this.customFinishError == '')) && (!this.selectedColorCount.value != '1' || (this.selectedColor.value == '1' && this.customColorCountError == '')) && (!this.selectedSubstrate.value != 'custom' || (this.selectedSubstrate.value == 'custom' && this.customSubstrateError == '')) && (!this.selectedGsm.value != 'custom' || (this.selectedGsm.value == 'custom' && this.customGsmError == '')) && (!this.selectedHandle.value != 'custom' || (this.selectedHandle.value == 'custom' && this.customHandleError == '')) && (!this.selectedHandleColor.value != 'custom' || (this.selectedHandleColor.value == 'custom' && this.customHandleColorError == '')) && (!this.selectedCardboard.value != 'custom' || (this.selectedCardboard.value == 'custom' && this.customCardboardError == '')) && (!this.selectedJslit.value != 'custom' || (this.selectedJslit.value == 'custom' && this.customcustomJslitError == '')) && (!this.selectedPrint.value != 'custom' || (this.selectedPrint.value == 'custom' && this.customcustomPrintError == '')) && (!this.selectedIp.value != 'custom' || (this.selectedIp.value == 'custom' && this.customcustomIpError == '')) ) {
            this.generateQuote()
          }
          else {
            this.validateAll()
          }
        }
        else {
          this.validateAll()
        }
      }
      else {
        this.generateQuote()
      }
      /*
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Form Submitted',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
      */
    },
    afterGenerated() {
      for (var j = 0; j < this.quoteResponse.length; j++) {

        var response = this.quoteResponse[j].data
        console.log('working on response: ' + JSON.stringify(response))
        if (response.amount_per_case) {
          var amount_per_case = response.amount_per_case
          var price_per_case = JSON.parse(JSON.stringify(response)).price_per_case
          var colored_handle_price = response.colored_handle_price
          var bottom_board_price = response.bottom_board_price
          var jslit_add_on = response.jslit_price

          var quant = (this.quoteItems[j].custom_quantity) ? this.quoteItems[j].custom_quantity : this.quoteItems[j].quantity.text


          if (this.quoteItems[j].handle_color.value == 1) {
            this.quoteItems[j].colored_handle = colored_handle_price
            this.displayItems[quant][j].add_on = colored_handle_price
          }

          if (this.quoteItems[j].cardboard.value == 'BOTTOM') {
            this.quoteItems[j].bottom_board = bottom_board_price
            this.displayItems[quant][j].add_on = this.displayItems[quant][j].add_on + bottom_board_price
          }

          if (this.quoteItems[j].jslit.value == 1 || this.quoteItems[j].cardboard.value == 'TOP') {
            this.quoteItems[j].jslit_add_on = jslit_add_on
            this.displayItems[quant][j].add_on = this.displayItems[quant][j].add_on + jslit_add_on
          }
          
          this.quoteItems[j].price_per_case = price_per_case
          this.quoteItems[j].amount_per_case = amount_per_case

          var temp_id = this.quoteItems[j].temp_id

          var price = this.quoteItems[j].price_per_case
          switch(this.quoteItems[j].cardboard.value) { 
            case 'BOTH':
              price = Number(price) + Number((0.07 * amount_per_case))
              break;
          }

          if (this.quoteItems[j].finish_id.value == 4) {
            price = Number(price) + Number((0.01 * amount_per_case))
          }

          if (this.quoteItems[j].handle_color.value == 1) {
            price = Number(price) + Number(this.quoteItems[j].colored_handle)
          }

          if (this.quoteItems[j].cardboard.value == 'BOTTOM') {
            price = Number(price) + Number(this.quoteItems[j].bottom_board)
          }

          if (this.quoteItems[j].jslit.value == 1 || this.quoteItems[j].cardboard.value == 'TOP') {
            price = Number(price) + Number(this.quoteItems[j].jslit_add_on)
          }
          
          for (var k = 0; this.displayItems[quant].length; k++) {
            if (this.displayItems[quant][k].temp_id == temp_id) {
              break;
            }
          }

          this.displayItems[quant][k].price = price
          this.displayItems[quant][k].price_per_case = price_per_case
          this.displayItems[quant][k].amount_per_case = amount_per_case


          this.quote = this.quote + price

          this.insertStatus = "AUTO_GENERATED"
        }
        else {
          this.customQuote = true
          break;
        }
        
      }
      this.openQuote()
    },
    quoteConfirmed() {
      this.confirmQuote = false

      for (var i = 0; i < this.quoteItems.length; i++) {
        if (this.quoteItems[i].custom_quote == 'custom') {
          this.afterQuote('custom')
          return
        }
      }

      for (var j = 0; j < this.quoteItems.length; j++) {
        var p_percent = ((this.quoteItems[j].print_percentage.value == '25' ||  this.quoteItems[j].print_percentage.value == '50' ||  this.quoteItems[j].print_percentage.value == '75') && this.quoteItems[j].color_count.text !=  4) ? '75' :  '100'
        this.quoteIteration = j

        var color_count_select = this.quoteItems[j].color_count.text

        if(p_percent = 100) {
          color_count_select = 4
        }

        var url = 'https://flexoapi.online/api/quote_get.php?' + 'size_id=' + this.quoteItems[j].size_id.value + '&gsm_id=' + this.quoteItems[j].gsm_id.value + '&quantity=' + this.quoteItems[j].request_quantity + '&print_percentage=' + p_percent + '&color_count=' + color_count_select + '&handle_type_id=' + this.quoteItems[j].handle_type_id.value + '&substrate_id=' + this.quoteItems[j].substrate_id.value 

        //console.log(url)

        axios
        .get(url)
        .then(response => (this.pushResponse(response)))
        .catch(function (error) {
          console.log('error: ' + error)
        })
        .finally(function () {

        })
      }

      /*
      if (this.quote != 'custom') {
        var url = 'https://flexoapi.online/api/quote_get.php?' + 'size_id=' + this.selectedSize.value + '&gsm_id=' + this.selectedGsm.value + '&quantity=' + this.requestQuantity + '&print_percentage=' + this.selectedPrint.value + '&color_count=' + this.selectedColorCount.value + '&handle_type_id=' + this.selectedHandle.value + '&substrate_id=' + this.selectedSubstrate.value 

        axios
        .get(url)
        .then(response => (this.afterQuote(response.data.price_per_unit, response.data.amount_per_case)))
        .catch(function (error) {
          console.log('error: ' + error)
        })
        .finally(function () {

        })
      }
      else {
        this.afterQuote('custom')
      }
      */
    },
    pushResponse(response){
      this.pushedAmount = this.pushedAmount + 1
      this.quoteResponse.push(response)
      if (this.pushedAmount == this.quoteItems.length) {
        this.afterGenerated()
      }
    },
    validationFormGeneral() {
      return new Promise((resolve, reject) => {
        this.$refs.sizeRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormSubstrate() {
      return new Promise((resolve, reject) => {
        this.$refs.substrateRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormGsm() {
      return new Promise((resolve, reject) => {
        this.$refs.gsmRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormHandle() {
      return new Promise((resolve, reject) => {
        this.$refs.handleRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormFinish() {
      return new Promise((resolve, reject) => {
        this.$refs.finishRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormCardboard() {
      return new Promise((resolve, reject) => {
        this.$refs.cardboardRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormColor() {
      return new Promise((resolve, reject) => {
        this.$refs.colorRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormPrint() {
      return new Promise((resolve, reject) => {
        this.$refs.PrintRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormIP() {
      return new Promise((resolve, reject) => {
        this.$refs.ipRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormQuantity() {
      return new Promise((resolve, reject) => {
        this.$refs.quantityRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormEffects() {
      return new Promise((resolve, reject) => {
        this.$refs.effectsRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    logoUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.logo = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.logo
    },
    generateQuote() {
      //this.quote = this.prices[this.selectedSize.value][this.selectedSubstrate.value][this.selectedPrint.value][this.selectedQuantity.value]

      var quantCheck = (this.selectedQuantity.value != 1) ? this.selectedQuantity.text.replace(/[^a-zA-Z0-9 ]/g, '') : this.customQuantity;

      if (quantCheck <= 3000) {
        this.requestQuantity = 3000
      }
      else if (quantCheck <= 5000) {
        this.requestQuantity = 5000
      }
      else if (quantCheck <= 10000) {
        this.requestQuantity = 10000
      }
      else if (quantCheck <= 25000) {
        this.requestQuantity = 25000
      }
      else if (quantCheck <= 50000) {
        this.requestQuantity = 50000
      }
      else if (quantCheck <= 100000) {
        this.requestQuantity = 100000
      }
      else {
        this.requestQuantity = quantCheck
        this.quote == 'custom'
      }

      if (this.selectedSubstrate.value != 1 && this.selectedSubstrate.value != 2 && this.selectedSubstrate.value != 3 && this.selectedSubstrate.value != 4) {
        this.quote == 'custom'
      }

      if (this.selectedGsm.value == 7 || this.selectedGsm.value == 8 || this.selectedGsm.value == 9) {
        this.selectedGsm.value = 9
      }
      else if (this.selectedGsm.value == 10 || this.selectedGsm.value == 11) {
        this.selectedGsm.value = 11
      }
      else {
        this.quote = 'custom'
      }

      if (this.selectedHandle.value != 1) {
        this.quote = 'custom'
      }

      if (this.selectedIp.value == 1) {
        this.quote = 'custom'
      }

      if (this.otherEffects) {
        this.quote = 'custom'
      }

      //?????????????????????
      if (this.selectedFinish.value != 4 && this.selectedFinish.value != 5) {
        this.quote = 'custom'
      }

      const currentDate = new Date();
      const timestamp = currentDate.getTime();

      var newItem = {
         'color_count': (this.selectedColorCount.value == '1') ? { value: 'custom', text: this.customColorCount } : this.selectedColorCount,
         'finish_id': (this.selectedFinish.value == '1') ? { value: 'custom', text: this.customFinish } : this.selectedFinish,
         'gsm_id': (this.selectedGsm.value == 'custom') ? { value: 'custom', text: this.customGsm } : this.selectedGsm,
         'handle_type_id': (this.selectedHandle.value == 'custom') ? { value: 'custom', text: this.customHandle } : this.selectedHandle,
         'handle_color': (this.selectedHandleColor.value == 'custom') ? { value: 'custom', text: this.customHandleColor } : this.selectedHandleColor,
         'size_id': (this.selectedSize.value == '1') ? { value: 'custom', text: this.customSize } : this.selectedSize,
         'substrate_id': (this.selectedSubstrate.value == 'custom') ? { value: 'custom', text: this.customSubstrate } : this.selectedSubstrate,
         'cardboard': (this.selectedCardboard.value == 'custom') ? { value: 'custom', text: this.customCardboard } : this.selectedCardboard,
         'jslit': (this.selectedJslit.value == 'custom') ? { value: 'custom', text: this.customJslit } : this.selectedJslit,
         'print_percentage': (this.selectedPrint.value == 'custom') ? { value: 'custom', text: this.customPrint } : this.selectedPrint,
         'inside_printing': (this.selectedIp.value == 'custom') ? { value: 'custom', text: this.customIp } : this.selectedIp,
         'quantity': (this.selectedQuantity.value == '1') ? { value: 'custom', text: this.customQuantity } : this.selectedQuantity,
         'custom_quantity': this.customQuantity,
         'request_quantity': this.requestQuantity,
         'other_effects': this.otherEffects,
         'custom_quote': this.quote,
         'temp_id' : timestamp,
      }

      this.quoteItems.push(newItem)

      var quant = (this.customQuantity) ? this.customQuantity : this.selectedQuantity.text

      if (this.displayItems[quant]) {
        this.displayItems[quant].push(newItem)
      }
      else {
        this.displayItems[quant] = []
        this.displayItems[quant].push(newItem)
        
      }
      
      this.confirmQuote = true
    },
    afterQuote(quote, amount_per_case) {
      if (quote == 'custom') {
        this.quote = ''
        this.customQuote = true
        this.insertStatus = "REQUESTED"

        this.openQuote()
      }
      else {
        for (var i = 0; i < this.quoteItems.length; i++) {
          var price = this.quoteItems[i].price_per_case
          switch(this.quoteItems[i].cardboard.value) { 
            case 'BOTH':
              price = price + (0.07 * amount_per_case)
              break;
            }

            if (this.quoteItems[i].finish_id.value == 4) {
              price = price + (0.01 * amount_per_case)
            }

            if (this.selectedHandleColor.value == 1) {
              price = price + (this.quoteItems[i].colored_handle * amount_per_case)
            }

            if (this.selectedCardboard.value == 'BOTTOM') {
              price = price + (this.quoteItems[i].bottom_board * amount_per_case)
            }

            if (this.selectedJslit.value == 1 || this.selectedCardboard.value == 'TOP') {
              price = price + (this.quoteItems[i].jslit * amount_per_case)
            }

            for (var i = 0; i < this.displayItems.length; i++) {
              //console.log('item ' + i + ': ' + JSON.stringify(this.displayItems[i]))
            }

            this.quoteItems[i].price = price
            this.displayItems[this.quoteItems[i].quantity.text].price = price

            this.quote = this.quote + price

            this.insertStatus = "AUTO_GENERATED"

            //this.casePackAmount = amount_per_case
        }
      }
    },
    openQuote(){
      this.quoteGenerated = true

      const date = new Date()
      this.quoteId = ((this.userData.first_name[0]) ? this.userData.first_name[0] : '') + ((this.userData.last_name[0]) ? this.userData.last_name[0] : '') + String(date.getMonth() + 1).padStart(2, '0') + String(date.getDate()).padStart(2, '0') + date.getFullYear() + Math.floor(100 + Math.random() * 900)

      for (var i = 0; i < this.quoteItems.length; i++) {
        var data = JSON.stringify({
          "quote_id": this.quoteId,
          "user_id": this.userData.id,
          "status": (this.customQuote) ? 'REQUESTED' : 'AUTO_GENERATED',
          "color_count": this.quoteItems[i].color_count.text,
          //"custom_color_count" : this.quoteItems[i].custom_color_count,
          "finish_id": this.quoteItems[i].finish_id.value,
          //"custom_finish": this.quoteItems[i].custom_finish,
          "gsm_id": this.quoteItems[i].gsm_id.value,
          //"custom_gsm": '',
          "handle_type_id": this.quoteItems[i].handle_type_id.value,
          "handle_color": this.quoteItems[i].handle_color.value,
          //"custom_handle": '',
          "size_id": this.quoteItems[i].size_id.value,
          //"custom_size": this.quoteItems[i].custom_size,
          "substrate_id": this.quoteItems[i].substrate_id.value,
          //"custom_substrate": '',
          "cardboard": this.quoteItems[i].cardboard.value,
          //"custom_cardboard": '',
          "jslit": this.quoteItems[i].jslit.value,
          "print_percentage": this.quoteItems[i].print_percentage.value,
          //"custom_print_percent": '',
          "inside_printing": this.quoteItems[i].inside_printing.value,
          "quantity": this.quoteItems[i].quantity.text,
          //"custom_quantity": this.quoteItems[i].custom_quantity,
          "other_effects": this.quoteItems[i].other_effects,
          "quoted_price_per_unit": (this.insertStatus == 'REQUESTED') ? '' : this.quote,
          "case_count": this.quoteItems[i].amount_per_case,
          "price_per_case": Number(this.quoteItems[i].price).toFixed('2'),
          "total_price": (Number(this.quoteItems[i].price) * (this.quoteItems[i].quantity.text / this.quoteItems[i].amount_per_case)).toFixed('2'),
          "print_name": this.printName,
        });

        this.quote_data = data

        //console.log('request data: ' +  data)

          var config = {
            method: 'post',
            url: 'https://flexoapi.online/api/quote_insert.php',
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };

          axios(config)
          .then(response => (console.log('')))
          .catch(function (error) {
            console.log(error);
          });
      }

      

        var body = ''
        var subject = ''
        if(this.insertStatus=='AUTO_GENERATED') {
          body +='<br><strong>New Quote Generated for: </strong>';
          subject = 'Quote Generated'
        }
        else {
          body +='<br><strong>New Quote Request from: </strong>';
          subject = 'New Quote Request'
        }

        //<b>Sides: </b>' +  this.selectedSide.value + '<br>
        body += this.userData.first_name + ' ' + this.userData.last_name + '<br><br><strong>Email Address: </strong>' + this.userData.login_email + '<br><br><strong>Quote ID: </strong>' + this.quoteId + '<br><br><strong>Print Name: </strong>' + this.printName + '<br><br><strong><i>ITEMS:</i></strong>';

        for (var i = 0; i < this.quoteItems.length; i++) {
          body += '<br>----------------------<br>' + '<br><br><strong>Size: </strong>' + this.quoteItems[i].size_id.text + '<br><strong>Paper Material: </strong>' +  this.quoteItems[i].substrate_id.text + '<br><strong>Top or Bottom Cardboard: </strong>' +  this.quoteItems[i].cardboard.text + '<br><strong>J Slit: </strong>' +  this.quoteItems[i].cardboard.text + '<br><strong>Handle Style: </strong>' + this.quoteItems[i].handle_type_id.text + '<br><strong>Colored Handle: </strong>' + this.quoteItems[i].handle_color.text + '<br><strong>Color Count: </strong>' + this.quoteItems[i].color_count.text + '<br><strong>Print %: </strong>' + this.quoteItems[i].print_percentage.text + '<br><strong>Paper Weight: </strong>' + ((this.quoteItems[i].gsm_id.value == 'custom') ? 'TBD' : ((this.quoteItems[i].gsm_id.text / 1.5).toFixed('2'))) + '<br><strong>GSM: </strong>' +  this.quoteItems[i].gsm_id.text + '<br><strong>Inside Printing Sides: </strong>' +  this.quoteItems[i].inside_printing.text + '<br><strong>Quantity: </strong>' + this.quoteItems[i].quantity.text + '<br><strong>Finish:</strong>' + this.quoteItems[i].finish_id.text + ((this.customQuote) ? ('<br><strong>Notes: </strong>' + this.quoteItems[i].other_effects) : ('<br><strong>Items Per Case: </strong>' + this.quoteItems[i].amount_per_case + '<br><strong>Price Per Case: </strong> $' + Number(this.quoteItems[i].price).toFixed('2') + '<br><strong>Total Price: </strong> $' + (Number(this.quoteItems[i].price) * (this.quoteItems[i].quantity.text / this.quoteItems[i].amount_per_case)).toFixed('2')))
          }

          //console.log('url: ' + 'https://flexoapi.online/api/sendgrid_send.php?to=quotes@flexocraft.com&name=Flexocraft Quotes&subject=' + subject + '&body=' + body)

        //to quote department
        //quotes@flexocraft.com
        let receiver = (this.userType == 'ADMIN') ? 'chanyw.cw@gmail.com' : 'quotes@flexocraft.com';
        var config = {
          method: 'get',
          url: 'https://flexoapi.online/api/sendgrid_send.php?to='+receiver+'&name=Flexocraft Quotes&subject=' + subject + '&body=' + body,
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };

        axios(config)
        .then(response => (console.log('')))
        .catch(function (error) {
          console.log(error);
        });


        if (!this.customQuote && this.userType != 'ADMIN') {
          //to customer - need to update to use this.userData.email - which still needs to be set in dashboard
          //console.log('email: ' + this.userData.login_email)

          var custBody = ''
          
          custBody +='<br><strong>Here is a review of your quote: </strong><br>';

          //<b>Sides: </b>' +  this.selectedSide.value + '<br>
          custBody += this.userData.first_name + ' ' + this.userData.last_name +'<br><br><strong>Print Name: </strong>' + this.printName + '<br><br><strong>Quote ID: </strong>' + this.quoteId + '<br><br><strong><i>ITEMS:</i></strong>';

          for (var i = 0; i < this.quoteItems.length; i++) {
            custBody += '<br>----------------------<br>' + '<br><br><strong>Size: </strong>' + this.quoteItems[i].size_id.text + '<br><strong>Paper Material: </strong>' +  this.quoteItems[i].substrate_id.text + '<br><strong>Top or Bottom Cardboard: </strong>' +  this.quoteItems[i].cardboard.text + '<br><strong>J Slit: </strong>' +  this.quoteItems[i].cardboard.text + '<br><strong>Handle Style: </strong>' + this.quoteItems[i].handle_type_id.text + '<br><strong>Colored Handle: </strong>' + this.quoteItems[i].handle_color.text + '<br><strong>Color Count: </strong>' + this.quoteItems[i].color_count.text + '<br><strong>Print %: </strong>' + this.quoteItems[i].print_percentage.text + '<br><strong>Paper Weight: </strong>' + ((this.quoteItems[i].gsm_id.value == 'custom') ? 'TBD' : ((this.quoteItems[i].gsm_id.text / 1.5).toFixed('2'))) + '<br><strong>GSM: </strong>' +  this.quoteItems[i].gsm_id.text + '<br><strong>Inside Printing Sides: </strong>' +  this.quoteItems[i].inside_printing.text + '<br><strong>Quantity: </strong>' + this.quoteItems[i].quantity.text + '<br><strong>Finish:</strong>' + this.quoteItems[i].finish_id.text + ((this.customQuote) ? ('<br><strong>Notes: </strong>' + this.quoteItems[i].other_effects) : ('<br><strong>Items Per Case: </strong>' + this.quoteItems[i].amount_per_case + '<br><strong>Price Per Case: </strong> $' + Number(this.quoteItems[i].price).toFixed('2') + '<br><strong>Total Price: </strong> $' + (Number(this.quoteItems[i].price) * (this.quoteItems[i].quantity.text / this.quoteItems[i].amount_per_case)).toFixed('2')))
          }

          //console.log('sending to cust: ' + 'https://flexoapi.online/api/sendgrid_send.php?to=' + this.userData.login_email + '&name='+ this.userData.first_name + ' ' + this.userData.last_name +'&subject=' + 'Flexocraft Quote' + '&body=' + custBody)
          
          //this.userData.login_email
          var config = {
            method: 'get',
            url: 'https://flexoapi.online/api/sendgrid_send.php?to=' + this.userData.login_email + '&name='+ this.userData.first_name + ' ' + this.userData.last_name +'&subject=' + 'Flexocraft Quote' + '&body=' + custBody,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };

          axios(config)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
          
        }

        return;
    },
    print(){
      html2pdf(document.getElementById('element-to-convert'));
    },
    setElements(res, el='') {
      for (var i=0; i<res.length; i++) {
        switch(el) {
          case 'sizes':
            this.sizeOptions.push({ value: res[i].id, text: res[i].size})
            break;
          case 'substrates':
            this.substrateOptions.push({ value: res[i].id, text: res[i].substrate})
            break;
          case 'gsm':
            this.gsmOptions.push({ value: res[i].id, text: res[i].gsm})
            break;
          case 'handle_types':
            this.handleOptions.push({ value: res[i].id, text: res[i].handle_type})
            break;
          case 'finishes':
            this.finishOptions.push({ value: res[i].id, text: res[i].finish})
            break;
          case 'quantities':
            this.quantityOptions.push({ value: res[i].id, text: res[i].quantity})
            break;
        }
      }
    },
    getElements(el='') {
      var url = 'https://flexoapi.online/api/quote_elements_get.php?get_table=' + el
      axios
      .get(url)
      .then(response => (this.setElements(response.data, el)))
      .catch(function (error) {
        console.log('error: ' + error)
      })
      .finally(function () {

      })
    },
  },
  mounted () {
    this.getElements('sizes')
    this.getElements('substrates')
    this.getElements('gsm')
    this.getElements('handle_types')
    this.getElements('finishes')
    this.getElements('quantities')
    this.userData = JSON.parse(localStorage.getItem('userData'))
    this.userType = this.userData.permissions
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle
    },
    currentDate() {
      return '4/27/2022'
    },
    validUntil() {
      return '5/27/2022'
    },
    dateDay(){
      var date = new Date();
      var day = date.getDate().toString()
      if (day.length < 2) {
       return '0' + day
      }
      else {
        return day
      }
    },
  }
}
</script>

<style lang="scss">
	.overlay {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.3);
		z-index: 100;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.modal {
		width: 500px;
		box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
		border-radius: 4px;
		background: white;
	}
	.modal__title {
		color: #38404f;
		@apply flex items-center justify-between p-3 font-bold;
	}
